import {
  PONItem,
  CartonSizeItem,
  CreateDataItem,
  ViewDataItem,
} from "../definitions";
export function createCartonSizeItem(ref?: CartonSizeItem): CartonSizeItem {
  return {
    productCode: ref?.productCode || "",
    productId: ref?.productId || 0,
    propertyCode: ref?.propertyCode || "",
    propertyId: ref?.propertyId || 0,
    quantity: ref?.quantity || 0,
    length: null,
    width: null,
    height: null,
    perBoxQuantity: null,
    boxQuantity: null,
    outerBoxGrossWeight: null,
    outerBoxNetWeight: null,
  };
}
export function isPositiveWeight(
  val: number | string | null | undefined
): boolean {
  const s = String(val).trim();
  if (!s) {
    return false;
  }
  if (!/^[+]?\d+(\.\d{1,4})?$/.test(s)) {
    return false;
  }
  return Number(s) > 0;
}
export function isQuantityValue(val: number | string | null) {
  return /^\d+$/.test(String(val));
}
export function transformCreateDataItemToPONItem(
  data: CreateDataItem
): PONItem {
  const ponItem: PONItem = {
    arrivalItemId: data.arrivalItemId,
    deliveryCode: data.deliveryCode,
    deliveryId: data.deliveryId,
    deliveryItemId: data.deliveryItemId,
    purchaseOrderCode: data.purchaseOrderCode,
    packageCode: data.packageCode,
    cartonSizeList: [],
  };
  const cartonSizeItem: CartonSizeItem = {
    productCode: data.productCode,
    productId: data.productId,
    propertyCode: data.propertyCode,
    propertyId: data.propertyId,
    quantity: data.quantity,
    length: null,
    width: null,
    height: null,
    perBoxQuantity: null,
    boxQuantity: null,
    outerBoxGrossWeight: null,
    outerBoxNetWeight: null,
  };
  ponItem.cartonSizeList = [cartonSizeItem];
  return ponItem;
}
export function transformViewDataItemToPONItem(data: ViewDataItem): PONItem {
  const ponItem: PONItem = {
    arrivalItemId: data.arrival_item_id as number,
    deliveryCode: "",
    deliveryId: 0,
    deliveryItemId: 0,
    purchaseOrderCode: data.purchase_order_code || "",
    packageCode: data.package_code,
    cartonSizeList: (data.detaillist || []).map(
      (dt) =>
        ({
          productCode: data.product_code || "",
          productId: data.product_id || 0,
          propertyCode: data.property_code,
          propertyId: data.property_id,
          quantity: dt.num,
          length: dt.longest_side !== undefined ? dt.longest_side : null,
          width: dt.second_long_side !== undefined ? dt.second_long_side : null,
          height: dt.shortest_side !== undefined ? dt.shortest_side : null,
          perBoxQuantity:
            dt.num_of_single_box !== undefined ? dt.num_of_single_box : null,
          boxQuantity: dt.num_of_boxes !== undefined ? dt.num_of_boxes : null,
          outerBoxGrossWeight:
            dt.outer_box_gross_weight !== undefined
              ? dt.outer_box_gross_weight
              : null,
          outerBoxNetWeight:
            dt.outer_box_net_weight !== undefined
              ? dt.outer_box_net_weight
              : null,
        } as CartonSizeItem)
    ),
  };
  return ponItem;
}
